import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';
import { StoreState } from '@mm/state/store-interfaces';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';

import { SlideoutContent } from './SlideoutContent/SlideoutContent';
import { SlideoutHeader } from './SlideoutHeader/SlideoutHeader';
import { SlideoutSearch } from './SlideoutSearch/SlideoutSearch';
import { SlideoutTabs } from './SlideoutTabs/SlideoutTabs';
import { SlideoutAddForm } from './SlideoutAddForm/SlideoutAddForm';
import { SlideoutItem } from './SlideoutItem/SlideoutItem';

import './SlideoutMenu.scss';

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;
type OuterProps = {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  setRef?: (ref: HTMLElement) => void;
};

type Props = PropsFromDispatch & OuterProps;

const SlideoutMenuPure = ({ children, className, setRef }: Props) => {
  return (
    <div
      ref={(ref: HTMLDivElement) => setRef?.(ref)}
      className={classNames(className, 'slideout-menu')}
    >
      {children}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  hideSlideoutMenu: () => dispatch(hideSlideoutMenu()),
});

const SlideMenuWithConnect = connect(
  null,
  mapDispatchToProps,
)(SlideoutMenuPure);

type ComponentType = typeof SlideMenuWithConnect & {
  Content: typeof SlideoutContent;
  Header: typeof SlideoutHeader;
  Search: typeof SlideoutSearch;
  Tabs: typeof SlideoutTabs;
  AddForm: typeof SlideoutAddForm;
  Item: typeof SlideoutItem;
};

const SlideoutMenu = SlideMenuWithConnect as ComponentType;

SlideoutMenu.Content = SlideoutContent;
SlideoutMenu.Header = SlideoutHeader;
SlideoutMenu.Search = SlideoutSearch;
SlideoutMenu.Tabs = SlideoutTabs;
SlideoutMenu.AddForm = SlideoutAddForm;
SlideoutMenu.Item = SlideoutItem;

export { SlideoutMenu };
